import { z } from 'zod';

// =============================================================================
// INVITE PREVIEW — GET /api/invites/preview
// Public (unauthenticated) endpoint. Returns enough display info for the signup
// page to render personalized copy. Does NOT echo the invitee's email back —
// the user just opened their email at that address, no need to reflect it,
// and not echoing reduces leakage if the URL ends up in browser history,
// referrer logs, or client-side telemetry.
// =============================================================================

export const invitePreviewQuery = z.object({
  token: z.string().min(1).max(2048),
});

export const invitePreviewResponse = z.object({
  inviter_name: z.string(),
  entity_id: z.string().uuid(),
  entity_name: z.string(),
  entity_type: z.enum(['org', 'hub']),
  role: z.enum(['org_admin', 'admin', 'team_user', 'user']),
  expires_at: z.string().datetime(),
});

export type InvitePreviewResponse = z.infer<typeof invitePreviewResponse>;
